// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageEN = {
  seo: {
    title: 'AI Transparency | pAIoneer Labs GmbH',
    description: 'How pAIoneer Labs GmbH uses artificial intelligence and provides information about it: AI assistant, labelling of AI-generated content, editorial responsibility and contact under the AI Act.',
    keywords: 'AI transparency, Artificial Intelligence Act, AI Act, Art.\u00a050, labelling, AI assistant, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'AI Transparency',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'AI Transparency',
    subtitle: 'How pAIoneer Labs GmbH uses artificial intelligence and provides information about it.'
  },
  sections: [
    {
      title: 'Legal framework',
      paragraphs: [
        'Since 2 August 2026, the transparency obligations under Art.\u00a050 of Regulation (EU) 2024/1689 on artificial intelligence (Artificial Intelligence Act, “AI Act”) have applied. In Germany, under the KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG, the German Act on AI Market Surveillance and the Promotion of Innovation), the Bundesnetzagentur (German Federal Network Agency) is the market surveillance authority and complaints office for the AI Act.',
        'This page describes which AI systems pAIoneer Labs GmbH uses and how it provides information about them. How personal data are processed in this context is described in the Privacy Policy.'
      ]
    },
    {
      title: 'AI assistant in our application',
      paragraphs: [
        'In our application, an AI assistant answers your questions. It is an AI system: its answers are generated automatically by language models and may be incorrect. Check important information before you base decisions on it.',
        'The application points this out before your first input and permanently beside the chat (Art.\u00a050\u2060(1) AI Act). In addition, every answer of the assistant is marked in a machine-readable format as AI-generated (Art.\u00a050\u2060(2) AI Act).',
        'The language models are provided via the service of OpenRouter, Inc., USA.'
      ]
    },
    {
      title: 'Direct communication with AI systems',
      paragraphs: [
        'Where an AI system of pAIoneer Labs GmbH communicates directly with you, for example in a chat, it identifies itself as an AI system at the latest at the first interaction.'
      ]
    },
    {
      title: 'Content of this website',
      paragraphs: [
        'The texts of this website – including where AI tools assist in their creation – are reviewed by pAIoneer Labs GmbH and published under its editorial responsibility (Art.\u00a050\u2060(4), second subparagraph, AI Act).',
        'We label image, audio or video content that has been generated or altered with AI and that depicts real persons, places or events in a deceptively realistic manner as artificially generated or altered (Art.\u00a050\u2060(4), first subparagraph, AI Act).'
      ]
    },
    {
      title: 'Analysis with machine learning',
      paragraphs: [
        'With your consent, we evaluate visitor statistics using machine-learning methods; details are given in the Privacy Policy. In doing so, we use neither emotion recognition nor biometric categorisation (Art.\u00a050\u2060(3) AI Act). The distinction between humans and automated access is based on technical characteristics of the device, browser and connection, not on biometric data.'
      ]
    },
    {
      title: 'Complaint',
      paragraphs: [
        'You can lodge a complaint about a possible infringement of the AI Act with the Bundesnetzagentur, the market surveillance authority and complaints office for the AI Act in Germany. It provides information on this at bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Contact',
    description: 'For questions about the use of artificial intelligence, you can reach us by email.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Last updated: 30 October 2026. The German version is authoritative.'
};
